import { useSelector } from 'Modules/core/redux';


export const useUserIsUnpaid = () => {
    const result = useSelector<boolean>('user.isUnpaid');
    return result;
};
